import { FC, useMemo } from 'react';
// import cs from 'classnames';
import { Row, Col, Tooltip } from 'antd';
// import cs from 'classnames';
import styles from './index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
import AgeDistribution from './components/AgeDistribution';
import EducationRatio from './components/EducationRatio';
import ConsumeLevelRatio from './components/ConsumeLevelRatio';
import FoodConsumeLevelRatio from './components/FoodConsumeLevelRatio';
import HousePriceRatio from './components/HousePriceRatio';
import VisitPreferenceRatio from './components/VisitPreferenceRatio';
import ChildAgeRatio from './components/ChildAgeRatio';
import HasChildRatio from './components/HasChildRatio';
import { isArray } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { QuestionCircleOutlined } from '@ant-design/icons';
import CommonPie from './components/CommonPie';
import IncomeDistributionRatio from './components/IncomeDistributionRatio';
import { useSelector } from 'react-redux';

/**
 * @Description 客流画像
 * 删掉了旧的siteselectionmap文件夹，从该文件夹中迁移出来的
 * 目前选址地图详情抽屉和点位测评详情抽屉公用
 */
const PassengerFlowPortrait: FC<{
  ageDetail,
  overViewData?,
  isShareALQ?, // 是否奥乐齐的分享页
  showChildData?: boolean, // 是否展示孩子数据
  needHelp?: boolean, // 是否显示注释说明
  isSpotEvaluation?: boolean; // 来源是否是点位测评
}> = ({
  ageDetail,
  overViewData,
  isShareALQ = false,
  showChildData = false, // 是否展示孩子数据
  needHelp = false,
  isSpotEvaluation = false,
}) => {
  const tenantCheckInfo = useSelector((state: any) => state.common.tenantCheck);
  const isALQ = useMemo(() => {
    return !!tenantCheckInfo?.isALQ || isShareALQ;
  }, [tenantCheckInfo, isShareALQ]);

  const methods = useMethods({
    getOptions(item: any) {
      return isArray(item.parts) ? item.parts.map((part) => ({ name: part.name, value: part.rate })) : [];
    }
  });

  const chartsData = useMemo(() => {
    const result = {};
    ageDetail?.distributions?.forEach((item) => {
      if (item.type === '学历') {
        result['educational'] = methods.getOptions(item);
      } else if (item.type === '消费水平') {
        result['consumeLevel'] = methods.getOptions(item);
      } else if (item.type === '餐饮消费水平') {
        result['foodConsumeLevel'] = methods.getOptions(item);
      } else if (item.type === '居住社区房价等级' && overViewData?.housePrice) { // 产品逻辑，周边小区均价字段为空时不显示该图表
        result['housePrice'] = methods.getOptions(item);
      } else if (item.type === '到访偏好') {
        result['visitPreference'] = methods.getOptions(item);
      } else if (item.type === '未成年子女情况') { // 未成年子女情况/有无子女
        result['hasChildData'] = methods.getOptions(item);
      } else if (item.type === '孩子年龄') {
        result['childAge'] = methods.getOptions(item);
      } else if (item.type === '婚姻情况') {
        result['maritalStatusData'] = methods.getOptions(item);
      } else if (item.type === '收入分布') {
        result['incomeDistributionData'] = methods.getOptions(item);
      } else if (item.type === '有无车产') {
        result['hasVehicleData'] = methods.getOptions(item);
      } else if (item.type === '有无房产') {
        result['hasHouseData'] = methods.getOptions(item);
      }
    });
    return result;
  }, [ageDetail, overViewData]);

  return (
    <div className={styles.chartsContainer}>
      {
        needHelp ? (
          <V2Title divider type='H2'>
            <div className={styles.titleHelpWrapper}>
              <div>客流画像</div>
              <Tooltip
                title={
                  <div>
                    <div>【年龄】</div>
                    <div>依据场所的目标客群年龄定位推导。</div>
                    <div>1.到访早教中心、母婴店、儿童疫苗接种点的客群，以25-35 岁育龄父母为主，该类场所服务婴幼儿群体，客群年龄与育儿阶段强相关；</div>
                    <div>2.到访健身房、潮流茶饮店、青年文创市集的客群，以18-30 岁青年群体为主，场所业态契合年轻群体的社交、健身需求；</div>
                    <div>3.到访老年大学、社区康养中心、棋牌室的客群，以55 岁以上中老年群体为主，业态聚焦中老年的休闲、康养需求。</div>
                    <br />
                    <div>【客群学历分布】</div>
                    <div>基于手机SDK活跃上报数据，通过大数据模型进行计算推测。主要根据线下生活方式场景进行判定。同时参考目标客群消费情况以及居住房价、车价、手机价格、是否出入高端消费场所等进行综合建模推算。</div>
                  </div>
                }
                placement='top'
                color='#fff'
                overlayInnerStyle={{
                  width: '314px',
                  boxSizing: 'border-box',
                  borderRadius: '4px',
                  color: 'rgba(0, 0, 0, 0.85)'
                }}
              >
                <>
                  <QuestionCircleOutlined className='fs-12 c-666 ml-2'/>
                </>
              </Tooltip>
            </div>
          </V2Title>
        ) : <V2Title divider type='H2' text='客流画像'/>
      }

      <div className={styles.desc}> {ageDetail?.introduction || '-'} </div>
      <Row gutter={16}>
        <Col span={12}>
          <AgeDistribution detail={ageDetail.ageRate} sexInfo={ageDetail.sexRate} />
        </Col>
        <Col span={12}>
          <EducationRatio detail={chartsData['educational']}/>
        </Col>
        <Col span={12} className='mt-16'>
          <ConsumeLevelRatio detail={chartsData['consumeLevel']}/>
        </Col>
        <Col span={12} className='mt-16'>
          <FoodConsumeLevelRatio detail={chartsData['foodConsumeLevel']}/>
        </Col>
        {
          isArray(chartsData['housePrice']) && chartsData['housePrice'].length ? <Col span={12} className='mt-16'>
            <HousePriceRatio detail={chartsData['housePrice']}/>
          </Col> : <></>
        }
        <Col span={12} className='mt-16'>
          <VisitPreferenceRatio detail={chartsData['visitPreference']}/>
        </Col>
        {
          showChildData && isArray(chartsData['hasChildData']) && chartsData['hasChildData'].length ? <Col span={12} className='mt-16'>
            <HasChildRatio data={chartsData['hasChildData']}/>
          </Col> : <></>
        }
        {
          showChildData && isArray(chartsData['childAge']) && chartsData['childAge'].length ? <Col span={12} className='mt-16'>
            <ChildAgeRatio data={chartsData['childAge']}/>
          </Col> : <></>
        }
        { // 奥乐齐租户的点位测评才会展示的模块
          (isSpotEvaluation && isALQ) && <>
            {
              isArray(chartsData['maritalStatusData']) && chartsData['maritalStatusData'].length && <Col span={12} className='mt-16'>
                <CommonPie
                  data={chartsData['maritalStatusData']}
                  title={'婚姻状况'}
                  colors={['#FFBE5E', '#35C3FF']}
                />
              </Col>
            }
            {
              isArray(chartsData['hasVehicleData']) && chartsData['hasVehicleData'].length && <Col span={12} className='mt-16'>
                <CommonPie
                  data={chartsData['hasVehicleData']}
                  title={'有无车产'}
                  colors={['#ED92CF', '#A896EF']}
                />
              </Col>
            }
            {
              isArray(chartsData['hasHouseData']) && chartsData['hasHouseData'].length && <Col span={12} className='mt-16'>
                <CommonPie
                  data={chartsData['hasHouseData']}
                  title={'有无房产'}
                  colors={['#89DECF', '#92ADED']}
                />
              </Col>
            }
            {
              isArray(chartsData['incomeDistributionData']) && chartsData['incomeDistributionData'].length && <Col span={12} className='mt-16'>
                <IncomeDistributionRatio data={chartsData['incomeDistributionData']}/>
              </Col>
            }
          </>
        }
      </Row>
    </div>
  );
};

export default PassengerFlowPortrait;
